<!-- 登录 -->
<template>
  <div class="login">
    <img src="https://cdn.welove520.com/static/res/vue/playbay/login.png">
    <div class="login_layout">
      <div class="item_input input1">
        <img src="https://cdn.welove520.com/static/res/vue/playbay/username.png">
        <input type="text" v-model="username"/>
      </div>

      <div class="item_input input2">
        <img src="https://cdn.welove520.com/static/res/vue/playbay/password.png">
        <input type="password" v-model="password"/>
      </div>

      <img class="login_btn" src="https://cdn.welove520.com/static/res/vue/playbay/login_btn.png" @click="login">
      <button class="register" @click="register">新用户注册</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      username: '',
      password: ''
    };
  },
  created() {
    this.$store.dispatch("initTabName", "login");
  },
  methods: {
    /**
     * 登录校验
     */
    login: function(){
      if(!this.username){
        alert("请填写用户名！");
        return;
      }

      if(!this.password){
        alert("请填写密码");
        return;
      }
    },

    /**
     * 注册
     */
    register: function(){
      this.$router.push({
        name: "Register"
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login {
  width: 660px;
  margin: 90px auto 50px auto;
  position: relative;
}

.login > img {
  width: 100%;
}

.login_layout {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

.item_input {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  position: absolute;
  z-index: 100;
  top: 0;
  right: 0;
  margin-right: 50px;
  border-radius: 50px;
  border: 1px solid #cecece;
  padding: 10px 18px;
  width: 235px;
}

input{
  outline: none;
}

.item_input > img {
  width: 15px;
}

.item_input > input {
  border: none;
  margin-left: 20px;
}

.input1 {
  margin-top: 110px;
}

.input2 {
  margin-top: 170px;
}

.login_btn {
  position: absolute;
  z-index: 100;
  top: 0;
  right: 0;
  width: 136px;
  margin-top: 250px;
  margin-right: 100px;
}

.register {
  position: absolute;
  z-index: 100;
  top: 0;
  right: 0;
  margin-top: 290px;
  margin-right: 140px;
  font-size: 10px;
  color: #88898e;
  text-align: center;
  text-decoration: underline;
  border: none;
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue